import { css } from 'emotion'

export const FileDropInputFieldStyles = css`
  .ErrorMessage {
    margin-top: 8px;
  }
`
